import { definePanel } from '@/app/definePanel';
import { EventsIcon } from '@/components/occurra/icons/EventsIcon';

export default definePanel({
    id: 'events_list',
    title: 'Events',
    description: 'What the agents reported. Filter by camera, type and rating.',
    icon: EventsIcon,
    // Fixed, not elastic — see objects_list, which shares this slot and rule:
    // the feed holds its width across stage resizes, and camera_view absorbs
    // the difference.
    width: { min: 480, default: 480, max: Infinity, fill: false },
    modes: ['view'],
    themes: 'any',
    // Mutual exclusion with objects_list (same "primary list" slot) lives
    // in src/app/exclusions.ts.
    // Inherits the original events_list slot. notifications/ sits just to the
    // left at 4.2 so the two related panels read naturally side-by-side.
    order: 4.3,
    // AI Search takes its place in the rail. The chat and the links of other panels still
    // open it.
    hasNavButton: false,
    // Scope the historic list to the camera selected elsewhere in the shell
    // (cameras panel, camera_view). Empty → show all cameras in the org.
    urlSyncedProps: ['cameraId'],
});
